module.exports = __webpack_public_path__ + "static/img/s11.c31126ca.png";